import React, { ReactNode } from 'react';
import { toast } from 'react-toastify';
import { Toast, TOAST_TYPE } from 'b2b-apps/shop/common/components/Toast';

export const showToast = (
  type: TOAST_TYPE,
  header: string | null,
  content: ReactNode | null | undefined,
  position?:
    | 'top-left'
    | 'top-right'
    | 'top-center'
    | 'bottom-left'
    | 'bottom-right'
    | 'bottom-center',
): void => {
  toast(
    <Toast type={type} header={header} content={content} />,
    {
      className: 'cds-Toast-Wrapper',
      progressClassName: 'cds-Toast-ProgressBar',
      position: position,
    },
  );
};
